import setSummary from "components/Orders/getOrderDetails";
import { ApiRequest, ShowLoader } from "GlobalFunctions";
import { validateLogic } from "../../utils/logicValidator";

// Store the shipping model globally for reuse
let globalShippingModel: HTMLElement | null = null;

/*========================================================
GET SHIPPING METHODS
=========================================================*/
export const getShippingMethods = async (getTaxes: () => Promise<void>) => {
    const subscription = JSON.parse(localStorage.getItem('subscription') || '{}');
    
    if(!subscription.client || !subscription.client.country || !subscription.client.state || !subscription.client.city_id) {
        await mapShippingMethods([], getTaxes);
        return;
    }
    // else {
    //     getTaxes();
    // }

    await ApiRequest({
        url: '/shipping/zones/getStoreShipping',
        method: 'POST',
        body: {
            cart: subscription
        },
        setResponse: async (response: any) => {
            await mapShippingMethods(response, getTaxes);
            if (response.length === 0) {
            }
            
        }
    });
}

/*========================================================
MAP SHIPPING METHODS
=========================================================*/
export const mapShippingMethods = async (shippingMethods: any, getTaxes: () => Promise<void>) => {
    const cart = JSON.parse(localStorage.getItem('subscription') || '{}');
    const shipping = cart.shipping;

    // Check if shipping exists and has a valid shipping_id
    if (shipping) {
        // Remove shipping property if shipping_id is 0 or doesn't exist
        delete cart.shipping;
        cart.shipping_price = 0;
        localStorage.setItem('subscription', JSON.stringify(cart));
    }
    
    /* LOGIC VALIDATOR
    =========================================================*/
    let adjustedShippingMethods = [...shippingMethods];
    try {
        const logicResult = await validateLogic({cart, logicMethod: 'shipping'});
        if (logicResult && logicResult.shippingLogic && logicResult.shippingLogic.length > 0) {
            for (const logic of logicResult.shippingLogic) {
                if (logic.addToAll) {
                    adjustedShippingMethods = adjustedShippingMethods.map((m) => ({ ...m, price: parseFloat(logic.price) }));
                } else if (logic.shippingMethods && logic.shippingMethods.length > 0) {
                    adjustedShippingMethods = adjustedShippingMethods.map((m) => {
                        const found = logic.shippingMethods.find((sm: any) => sm.shipping_id === m.shipping_id && sm.price !== undefined && sm.price !== "");
                        if (found) {
                            return { ...m, price: parseFloat(found.price) };
                        }
                        return m;
                    });
                }
            }
        }
    } catch (e) {
        console.error('Error applying shipping logic:', e);
    }

    // Store updated shipping methods in localStorage
    localStorage.setItem('shippingMethods', JSON.stringify(adjustedShippingMethods));

    // NUEVA LÓGICA: Usar <select pc="shipping">
    const select = document.querySelector('select[pc="shipping"]') as HTMLSelectElement | null;
    if (select) {
        // Limpiar opciones existentes
        select.innerHTML = '';

        // Opción inicial por defecto
        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.textContent = 'Select a shipping method...';
        select.appendChild(defaultOption);

        if (adjustedShippingMethods.length === 0) {
            // Si no hay métodos, solo mostrar la opción por defecto (ya agregada)
        } else {
            // Agregar opciones
            adjustedShippingMethods.forEach((method: any) => {
                const option = document.createElement('option');
                option.value = method.shipping_id;
                option.textContent = `${method.rate_name} - ${method.price === 0 ? 'Free' : '$' + parseFloat(method.price).toLocaleString()}`;
                option.dataset.shipping = JSON.stringify(method);
                select.appendChild(option);
            });

            // Listener para guardar el objeto completo al seleccionar
            select.onchange = async (e) => {
                const selectedIndex = select.selectedIndex;
                // Si selecciona la opción por defecto, no hacer nada
                if (selectedIndex === 0) return;
                const selectedMethod = adjustedShippingMethods[selectedIndex - 1];
                if (selectedMethod) {
                    // Read fresh cart data from localStorage to avoid stale data
                    const freshCart = JSON.parse(localStorage.getItem('subscription') || '{}');
                    freshCart.shipping = selectedMethod;
                    freshCart.shipping_price = Number(selectedMethod.price);
                    localStorage.setItem('subscription', JSON.stringify(freshCart));
                    await getTaxes();
                }
            };
        }
    }

    ShowLoader(false);

    if (cart.client || cart.client.s_city_id) {
        await getTaxes();
    }
}

/*=========================================================
FUNCTIONS TO BE CALLED /  CUSTOM CODE
=========================================================*/
// (window as any).mapShippingMethods = mapShippingMethods;



